var map = {
	"./lang0.mp3": 1948,
	"./lang1.mp3": 1949,
	"./lang10.mp3": 1950,
	"./lang11.mp3": 1951,
	"./lang12.mp3": 1952,
	"./lang13.mp3": 1953,
	"./lang2.mp3": 1954,
	"./lang3.mp3": 1955,
	"./lang4.mp3": 1956,
	"./lang5.mp3": 1957,
	"./lang6.mp3": 1958,
	"./lang7.mp3": 1959,
	"./lang8.mp3": 1960,
	"./lang9.mp3": 1961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1947;